import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemColumn,
  TableContentItemText,
  TableContent,
  TableContentItemCaptions,
  TableContentItemButton,
} from '../../../../../../components/TableContent';
import { mapCaptions } from '../../../../utils';

import { ResponsiveItemProps } from '.';

export const DesktopItem: React.FC<ResponsiveItemProps> = ({ item, handleSelect }) => {
  return (
    <TableContent direction="row">
      <TableContentItemColumn flex={2} space={Spacing['inline.quarck']}>
        <TableContentItemText>{item.name}</TableContentItemText>
        <TableContentItemCaptions icons={mapCaptions(item)} />
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.cpfCnpjFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.accountNumber}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemBadge>{item.suitabilityProfileName!}</TableContentItemBadge>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.registrationStatusName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemText>{item.availableBalanceFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn>
        <TableContentItemButton onPress={handleSelect} />
      </TableContentItemColumn>
    </TableContent>
  );
};
